<template>
<v-card>
  <v-layout row wrap>
    <v-flex xs5>
      <v-flex>
        <!-- <v-text-field solo
          v-model='splitter'
          hint='Character to use to split items'
          :persistent-hint="true" >
        </v-text-field> -->
      </v-flex>
      <v-divider></v-divider>

      <v-textarea rows='20' solo v-model='raw'></v-textarea>

      <v-layout>
        <v-flex xs6 >
          <v-card>
            <v-card-text class='headline' >
              {{clients.length}}
            </v-card-text>
            <v-card-actions>
              Current client count
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs6>
          <v-card>
            <v-card-text class='headline'>
              {{items.length}}
            </v-card-text>
            <v-card-actions>
              About to add
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

      <v-btn @click='getClients()' >Reload clients</v-btn>
      <v-btn @click='createAll' >Create</v-btn>
      <client-list class='mt-3' ></client-list>
    </v-flex>
    <v-flex xs7>
      <v-layout v-for='(item, index) in items' :key='index' row wrap >
        <v-flex class='text-xs-center' xs1>
          <v-progress-circular
            v-if='getRequest(item).loading'
            class='mt-2' color='amber' :size='30' indeterminate ></v-progress-circular>
          <v-icon
            v-if='getRequest(item).status === 201'
            color='green' class='mt-3' >check_cirle</v-icon>
          <v-icon
            v-if='getRequest(item).status > 299'
            color='red' class='mt-3' >warning</v-icon>
        </v-flex>
        <v-flex xs4>
          <v-text-field label='full name' v-model='item.full_name' ></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-text-field label='phone' v-model='item.phone_number' ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field label='email' v-model='item.email' ></v-text-field>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</v-card>
</template>

<script>
import { parse, format, isValidNumber } from 'libphonenumber-js'
import ClientList from '@/components/client/ClientList'

export default {
  name: 'BulkAddClients',
  components: { ClientList },
  data () {
    return {
      raw: 'Johannes Heyns\t769483326\tfheyns@heynscor.co.za\nJurie van Dyk\t824535846\tjurievandyk01@gmail.com',
      items: [],
      splitter: '\t'
    }
  },
  watch: {
    raw () {
      this.parseText(this.raw)
    }
  },
  computed: {
    clients () {
      return this.$store.getters.clients
    }
  },
  methods: {
    parseText (raw) {
      let rows = raw.split('\n')
      this.items = []
      let index = 0
      this.items = rows.map((item) => {
        index++
        let bits = item.split(this.splitter)
        let firstLast = this.splitName(bits[0])
        let phone = format(
          this.parsedNumber(bits[1]),
          'International_plaintext'
        )
        return {
          key: index,
          full_name: bits[0],
          first_name: firstLast[0],
          last_name: firstLast[1],
          phone_number: phone,
          email: bits[2].toLowerCase()
        }
      })
    },
    splitName (fullName) {
      let firstName = ''
      let lastName = ''
      if (fullName) {
        firstName = fullName.split(' ', 1).pop()
        lastName = fullName.split(' ').splice(1).join(' ')
      }
      return [firstName, lastName]
    },
    parsedNumber (number, countryCode = 'ZA') {
      return parse(number, countryCode)
    },
    isValidNumber () {
      if (!isValidNumber(this.parsedNumber)) {
        return 'Please enter a valid phone number'
      }
    },
    createAll () {
      this.items.forEach(this.create)
    },
    create (item) {
      let reqId = 'bulk-client-' + item.key
      this.$appointmentguru
        .resource('practitioner.clients.new')
        .id(reqId)
        .create(item)
    },
    getRequest (item) {
      let reqId = 'bulk-client-' + item.key
      return this.$store.getters.getRequestById(reqId, true)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// BulkAdd.vue?70fbe449